import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import { FormApi } from 'final-form';
import InputField from 'components/InputField';
import validations from 'validations';
import { Button } from 'ncoded-component-library';
import PencilIcon from 'icons/Pencil.icon';
import TrashIcon from 'icons/Trash.icon';

import './EditOption.styles.scss';

type EditOptionProps = {
  className?: string;
  isEditing?: boolean;
  showDelete?: boolean;
  value: string;
  initialValues: Record<string, string>;
  disabled?: boolean;
  onPencilClick: () => void;
  onCancel: () => void;
  onEdit: (values: Record<string, any>, form: FormApi) => void;
  onDelete: () => void;
};

const EditOption: React.FC<EditOptionProps> = (props) => {
  const {
    className,
    initialValues,
    value,
    isEditing = false,
    showDelete = true,
    disabled = false,
    onPencilClick,
    onCancel,
    onEdit,
    onDelete,
  } = props;

  const classes = classNames('edit-option', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      {isEditing && !disabled ? (
        <Form
          onSubmit={onEdit}
          initialValues={initialValues}
          render={({ handleSubmit, invalid, pristine }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name="name"
                autoFocus
                component={InputField}
                showErrorMsg={false}
                validate={validations.composeValidators(
                  validations.required(),
                  validations.minLength('min', 2),
                  validations.maxLength('max', 100),
                )}
              />

              <Button
                variant="outline"
                type="submit"
                disabled={invalid || pristine}
              >
                {t('save')}
              </Button>
              <Button variant="link" onClick={onCancel}>
                {t('cancel')}
              </Button>
            </form>
          )}
        />
      ) : (
        <>
          <p>{value}</p>
          {!disabled && (
            <Button variant="icon" icon={PencilIcon} onClick={onPencilClick} />
          )}
          {!disabled && showDelete && (
            <Button
              variant="icon"
              className="warning-action-button"
              icon={TrashIcon}
              onClick={onDelete}
            />
          )}
        </>
      )}
    </div>
  );
};

export default EditOption;
